var _line, _line2, _line3, _line4, _line5, _line6, _line7, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 130,
    viewBox: "0 0 507 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 168.695,
    y2: -0.5,
    transform: "matrix(0.999569 -0.0293771 0.0144636 0.999895 2.86584 124.884)",
    stroke: "#41867B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 171.651,
    y2: -0.5,
    transform: "matrix(0.982356 -0.18702 0.0932924 0.995639 2.86584 124.061)",
    stroke: "#FFD543"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 169.424,
    y2: -0.5,
    transform: "matrix(0.995268 -0.0971683 0.0479964 0.998847 2.86584 124.884)",
    stroke: "#EB6864"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 318.461,
    y2: -0.5,
    transform: "matrix(0.999138 -0.041506 0.0204418 0.999791 171.488 108.422)",
    stroke: "#EA6864"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 171.217,
    y2: -0.5,
    transform: "matrix(0.998334 -0.0576903 0.02843 0.999596 171.488 91.9592)",
    stroke: "#FFD543"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 147.344,
    y2: -0.5,
    transform: "matrix(0.99548 -0.0949697 0.0469029 0.998899 342.998 82.0815)",
    stroke: "#FFD543"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 178.625,
    y2: -0.5,
    transform: "matrix(0.956932 -0.290313 0.14768 0.989035 171.488 119.945)",
    stroke: "#41867B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.708 67.6765L489.676 58.622",
    stroke: "#41867B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.82272V129",
    stroke: "#E4E4E4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.64716,
    cy: 123.238,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#41867B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.739,
    cy: 91.3678,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#FFD543"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.202,
    cy: 81.2585,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#FFD543"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.529,
    cy: 100.422,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#EA6864"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.358,
    cy: 66.6738,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#FFD543"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.6192,
    cy: 123.47,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#EB6864"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.739,
    cy: 108.422,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#EA6864"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.458,
    cy: 94.4282,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#EA6864"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.739,
    cy: 119.354,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#41867B"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.202,
    cy: 68.0882,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#41867B"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.458,
    cy: 58.2105,
    rx: 2.93659,
    ry: 3.29253,
    fill: "#41867B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13318 129L507 129",
    stroke: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExample);
export default __webpack_public_path__ + "static/media/example.80905653268a524b67d950d0c40542d9.svg";
export { ForwardRef as ReactComponent };